import { Mic, Monitor, Shield, Tool, User } from 'react-feather';
import { TMenuBranch, TMenuLeaf } from '../components/types';
import {
    EVALUATION_AUTH,
    FINANCIAL_INSTITUTIONS_AUTH,
    UPLOAD_LEADS_AUTH,
    MAKE_AUTH,
    SOURCE_AUTH,
    STATUS_AUTH,
    STORE_AUTH,
    STORE_INTEGRATIONS_STATUS_AUTH,
    STORE_GOALS_AUTH,
    TEMPLATES_WSP_AUTH,
    VEHICLES_AUTH,
    AUTOMATIC_MAILING_AUTH,
    STORES_RECORDINGS_AUTH,
    RECORDING_TESTS_AUTH,
    AD_CAMPAIGN_AUTH,
    GROUPS_AUTH,
    STORE_GROUP_PERMISSION,
    INVESTMENTS_CHART_AUTH,
    MAINTENANCE_PACKAGE_AUTH,
} from 'src/constants/permissions';
import { DEVELOPER_LEVEL_ACCESS } from 'src/components/access';

export const LEAD_SETTINGS: TMenuLeaf[] = [
    {
        title: 'Navbar.Evaluations',
        path: '/management/evaluations',
        permission: EVALUATION_AUTH,
    },
    {
        title: 'Navbar.LoadLeads',
        path: '/management/load-leads',
        permission: UPLOAD_LEADS_AUTH,
    },
    {
        title: 'Navbar.Emails',
        path: '/management/mailing',
        permission: AUTOMATIC_MAILING_AUTH,
    },
];

export const MARKETING_SETTINGS: TMenuLeaf[] = [
    {
        title: 'Navbar.Campaigns',
        path: '/management/adCampaigns',
        permission: AD_CAMPAIGN_AUTH,
    },
    {
        title: 'Navbar.ChartInvestment',
        path: '/management/investments-chart',
        permission: INVESTMENTS_CHART_AUTH,
    },
];

export const SYSTEM_SETTINGS: TMenuLeaf[] = [
    {
        title: 'Navbar.AIPermissions',
        path: '/management/ai-permissions',
        accessLevels: [DEVELOPER_LEVEL_ACCESS],
    },
    {
        title: 'Navbar.Makes',
        path: '/management/makes',
        permission: MAKE_AUTH,
    },
    {
        title: 'Navbar.Stores',
        path: '/management/stores',
        permission: STORE_AUTH,
    },
    {
        title: 'Navbar.AgencyGoals',
        path: '/management/agency-goals',
        permission: STORE_GOALS_AUTH,
    },
    {
        title: 'Navbar.StoreIntegrations',
        path: '/management/store-integrations',
        permission: STORE_INTEGRATIONS_STATUS_AUTH,
    },
    {
        title: 'Navbar.Vehicles',
        path: '/management/vehicles',
        permission: VEHICLES_AUTH,
    },
    {
        title: 'Navbar.Sources',
        path: '/management/sources',
        permission: SOURCE_AUTH,
    },
    {
        title: 'Navbar.TemplatesTwilio',
        path: '/management/templates-wsp',
        permission: TEMPLATES_WSP_AUTH,
    },
    {
        title: 'Navbar.SystemNotifications',
        path: '/management/system-notifications',
        permission: TEMPLATES_WSP_AUTH,
    },
    {
        title: 'Navbar.Statuses',
        path: '/management/status',
        permission: STATUS_AUTH,
    },
    {
        title: 'Navbar.FinancialInstitution',
        path: '/management/financialInstitutions',
        permission: FINANCIAL_INSTITUTIONS_AUTH,
    },
    {
        title: 'Navbar.Groups',
        path: '/management/groups',
        permission: GROUPS_AUTH,
    },
    {
        title: 'Navbar.StoreGroups',
        path: '/management/store-groups',
        permission: STORE_GROUP_PERMISSION,
    },
];

export const RECORDINGS_SETTINGS: TMenuLeaf[] = [
    {
        title: 'Navbar.ManageRecordings',
        path: '/management/manage-recordings',
        permission: STORES_RECORDINGS_AUTH,
    },
    {
        title: 'Navbar.RecordingTest',
        path: '/management/recording-tests',
        permission: RECORDING_TESTS_AUTH,
    },
];

export const SERVICE_SETTINGS: TMenuLeaf[] = [
    {
        path: '/management/maintenance-packages',
        title: 'Navbar.MaintenancePackages',
        permission: MAINTENANCE_PACKAGE_AUTH,
    },
];

export const SETTINGS_MENU: (TMenuBranch | TMenuLeaf)[] = [
    {
        title: 'Navbar.SettingLeads',
        Icon: User,
        items: LEAD_SETTINGS,
    },
    {
        title: 'Navbar.Marketing',
        Icon: Monitor,
        items: MARKETING_SETTINGS,
    },
    {
        title: 'Navbar.Recordings',
        Icon: Mic,
        items: RECORDINGS_SETTINGS,
    },
    {
        title: 'Navbar.Service',
        Icon: Tool,
        items: SERVICE_SETTINGS,
    },
    {
        title: 'Navbar.System',
        Icon: Shield,
        items: SYSTEM_SETTINGS,
    },
];
